"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = init;
exports.openHelpCenter = openHelpCenter;
const types_1 = require("../webview/types");
const flagr_1 = require("../flagr");
const webview_1 = require("../webview");
const zendesk_1 = require("../zendesk");
function init() {
    (0, flagr_1.fetchFlags)();
}
function openHelpCenter(page) {
    if ((0, webview_1.isInWebView)()) {
        (0, webview_1.fireEvent)(types_1.WebViewEventName.TOGGLE_INTERCOM, { visible: true });
    }
    else {
        (0, zendesk_1.redirectToHelpCenter)(page);
    }
}
//# sourceMappingURL=index.js.map